import { amountFormat, amountToNumber } from '../../../../util/shared/vue-global';

export const applyAuditForPayment = ({
  item, initialPenaltyAmt, initialTaxAmt, item1,
  taxAmountChangesCreateAudit = false,
}) => {
  const auditMessages = [];
  let AIsVisible = false;
  // const halfPayment = amountToNumber(initialTaxAmt || 0) / 2;
  const suffix = `for Tax ID: ${item.taxId} and Tax Year: ${item.taxYear} `;

  const initialFees = item.initialFees || [];
  const currentFees = item.fees || [];

  currentFees.forEach((fee) => {
    const matchedInitialFee = initialFees
      .find((initialFee) => initialFee.feeNumber === fee.feeNumber);
    if (!matchedInitialFee) {
      AIsVisible = true;
      auditMessages.push(`Fee ${fee.feeNumber} for ${amountFormat(fee.feeAmount)} was added ${suffix}`);
    } else if (amountToNumber(fee.feeAmount) !== amountToNumber(matchedInitialFee.feeAmount)) {
      AIsVisible = true;
      auditMessages.push(`Fee ${fee.feeNumber} was changed from ${amountFormat(matchedInitialFee.feeAmount)} to ${amountFormat(fee.feeAmount)} ${suffix}`);
    }
  });

  initialFees.forEach((initialFee) => {
    const stillExists = currentFees
      .some((fee) => fee.feeNumber === initialFee.feeNumber);
    if (!stillExists) {
      AIsVisible = true;
      auditMessages.push(`Fee ${initialFee.feeNumber} for ${amountFormat(initialFee.feeAmount)} was deleted ${suffix}`);
    }
  });

  if (amountToNumber(initialPenaltyAmt) !== amountToNumber(item.penaltyAmt)) {
    AIsVisible = true;
    auditMessages.push(`Penalty changes from ${amountFormat(initialPenaltyAmt)} to ${amountFormat(item.penaltyAmt)} ${suffix}`);
  }
  // if ((amountToNumber(halfPayment) > amountToNumber(item.taxAmt)))
  const taxAmountChanged = amountToNumber(initialTaxAmt) !== amountToNumber(item.taxAmt);
  if (item1.isFirstTimePrintReceipt
    || (taxAmountChangesCreateAudit && taxAmountChanged)) {
    AIsVisible = true;
    auditMessages.push(`Tax amount changes from ${amountFormat(initialTaxAmt)} to ${amountFormat(item.taxAmt)} ${suffix}`);
  }
  let auditSummary = auditMessages.join('\n');
  if (item1.isFirstTimePrintReceipt) {
    auditSummary += ', change was made after receipt had been printed';
  }
  return {
    auditSummaryText: auditSummary,
    aIsVisible: AIsVisible,
  };
};

export default { applyAuditForPayment };
